"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var router_1 = require("@reach/router");

var React = __importStar(require("react"));

var uniqid_1 = __importDefault(require("uniqid"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Spinner_1 = require("../../webcomponents/Spinner/");

var Looks;

(function (Looks) {
  Looks["PRIMARY"] = "lsg--btn-primary";
  Looks["SECONDARY"] = "lsg--btn-secondary";
  Looks["NONE"] = "";
})(Looks || (Looks = {}));

exports.Looks = Looks;
var defaultProps = {
  look: Looks.PRIMARY,
  htmlAttrs: {}
};

exports.Button = function (_a) {
  var id = _a.id,
      className = _a.className,
      children = _a.children,
      disabled = _a.disabled,
      href = _a.href,
      to = _a.to,
      loading = _a.loading,
      look = _a.look,
      onMouseDown = _a.onMouseDown,
      onClick = _a.onClick,
      onKeyDown = _a.onKeyDown,
      onFocus = _a.onFocus,
      onBlur = _a.onBlur,
      target = _a.target,
      refCallback = _a.refCallback,
      htmlAttrs = _a.htmlAttrs;
  var uuid = id || uniqid_1["default"]("bpr-button-");
  var classNames = utils_1.DomUtils.cleanupClassNames([!loading && CSSPrefix_1.prefixEnumClassNames(look), loading && CSSPrefix_1.lsgPre + "button__loading", className, !children && "no-label"]);

  var internalOnClick = function internalOnClick(e) {
    var elm = document.getElementById(uuid);
    elm.classList.remove("clicked"); // tslint:disable-next-line

    void elm.offsetWidth; // https://css-tricks.com/restart-css-animation/#article-header-id-0

    elm.classList.add("clicked");
    return onClick && onClick(e);
  };

  var isLink = !!href || !!to;
  var Component = href ? "a" : to ? router_1.Link : "button";
  return React.createElement(Component, __assign({
    tabIndex: disabled ? -1 : undefined
  }, htmlAttrs, {
    className: classNames,
    disabled: disabled || loading || undefined,
    "aria-disabled": isLink && disabled ? "true" : undefined,
    href: href ? href : undefined,
    to: to,
    id: uuid,
    onClick: internalOnClick,
    onKeyDown: onKeyDown,
    onMouseDown: onMouseDown,
    onFocus: onFocus,
    onBlur: onBlur,
    ref: refCallback,
    target: isLink ? target : undefined,
    type: htmlAttrs.type || (isLink ? undefined : "button")
  }), React.createElement("span", {
    className: CSSPrefix_1.lsgPre + "button-text"
  }, children), loading && React.createElement("div", {
    className: CSSPrefix_1.lsgPre + "button-spinner"
  }, React.createElement(Spinner_1.Spinner, {
    variant: "indeterminate",
    size: 24,
    value: undefined
  })));
};

exports.Button.defaultProps = defaultProps;
exports.Button.Looks = Looks;
exports.Button.displayName = "Button";